import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v("\n\t\t"+_vm._s(_vm.map.blexonName)),_c('br'),_vm._v("\n\t\t"+_vm._s(_vm.map.blexonDescription)+"\n\t")]),_c('td',[_c(VTextField,{on:{"change":() => {
					_vm.map.fertigerName = _vm.map.fertigerName.trim();
					_vm.update();
				}},model:{value:(_vm.map.fertigerName),callback:function ($$v) {_vm.$set(_vm.map, "fertigerName", $$v)},expression:"map.fertigerName"}})],1),_c('td',[_c(VTextField,{on:{"change":() => {
					_vm.map.fertigerText = _vm.map.fertigerText.trim();
					_vm.update();
				}},model:{value:(_vm.map.fertigerText),callback:function ($$v) {_vm.$set(_vm.map, "fertigerText", $$v)},expression:"map.fertigerText"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }